// No URLSearchParams polyfill since 20 Oct 2026: every browser the bundle
// targets (esbuild.config.mjs: es2020, Chrome 90, Firefox 90, Safari 14) has
// it natively, and the polyfill cost about 1 KB gzipped of the 250 KB budget.
import React from 'react'
import ReactDOM from 'react-dom'
import { settings } from './store/constants'
import { AppProvider } from './app-provider'
import './assets/styles'
// Note: Image imports are handled by esbuild loader config

// Bootstrap Google Analytics 4 (gtag.js) directly - no Tag Manager.
// Loads asynchronously, defines window.gtag, and configures the GA4
// property. Subsequent gtag('event', ...) calls are picked up automatically.
function initGA4(measurementId) {
  if (!measurementId) return

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`
  document.head.appendChild(script)

  window.dataLayer = window.dataLayer || []
  window.gtag = function () { window.dataLayer.push(arguments) }
  window.gtag('js', new Date())
  window.gtag('config', measurementId)
}

// THE BUNDLE'S HALF OF THE LOCALHOST BRAND PREVIEW, and it is deliberately
// the smallest half that can work: one meta tag and one early return.
//
// The server can paint a whole alternative home page (app/views/gwmc/brand/,
// behind BrandPreview, which is false in the production environment whatever
// the environment says). Each of those is a complete document with its own
// masthead, running order and footer, so React must not mount: ReactDOM's
// render into #app replaces everything in it, and the preview would flash the
// page Robin asked to look at and then put the control back.
//
// NO WORLD IS IN THIS FILE: no copy, no class name, no colour, no price, no
// photograph. All of that is in Haml partials and a Propshaft stylesheet the
// production environment cannot render or link. What ships to a customer is
// the querySelector below, which finds nothing, and the SPA mounts as always.
const brandPreview = () => !!document.querySelector("meta[name='gwmc:brand']")

document.addEventListener('DOMContentLoaded', () => {
  // GA4 only records page views now (PostHog is the event pipeline), so it
  // can wait until the page has painted.
  window.addEventListener('load', () => setTimeout(() => initGA4(settings.googleAnalyticsMeasurementId), 1500), { once: true })
  // Localhost only, and never true in production: the server's own page is
  // the page, so there is nothing for React to do here.
  if (brandPreview()) return
  ReactDOM.render(<AppProvider />, document.getElementById('app') || document.body.appendChild(document.createElement('div')))
})
